import React, { useState, useMemo, useEffect } from 'react'
import { Input, TextArea, Button, Banner } from '@arnsbogroup/react-voicearchive'
import useValidate, { is } from '@arnsbogroup/react-voicearchive/hooks/useValidate'
import { Helmet } from 'react-helmet'
import { useSearchParams } from 'react-router-dom'
import useApi from 'hooks/useApi'
import {FormattedMessage, useIntl} from "react-intl";
import messages from "./messages";

const ProjectVote = ({ project, external = true, votes = {} }) => {
  const { formatMessage } = useIntl()
  const [searchParams] = useSearchParams()

  const [form, setForm] = useState({
    name: searchParams.get('name') || (external ? '' : project?.details?.name) || '',
    email: searchParams.get('email') || (external ? '' : project?.details?.email) || '',
    comment: searchParams.get('comment') || '',
  })

  const [validations, validate] = useValidate(form, external ? {
    name: [is.present],
    email: [is.present, is.email],
  } : {})

  const [data, loading, errors, refetch, meta] = useApi({ load: false })

  const onSubmit = () => {
    if (validate()) {
      refetch(`/rest/v2/project/${project.id}/vote`, {
        method: 'POST',
        body: JSON.stringify({ ...form, votes })
      })
    }
  }

  return (
    <div className="py-8">
      <Helmet>
        <title>
          {formatMessage(messages.pageTitle)}
        </title>
      </Helmet>

      { data ? (
        <Banner
          state={formatMessage(messages.bannerSucessState)}
          title={formatMessage(messages.bannerSucessTitle)}
          subtitle={formatMessage(messages.bannerSucessSubTitle)}
        />
      ) : errors.length ? (
        <Banner state="error" subtitle={errors.join(' ')} />
      ) : (
        <div className="flex flex-col md:flex-row justify-between space-y-4 md:space-y-0 md:space-x-4 px-4 md:px-0">
          <TextArea
            optional
            label={formatMessage(messages.commentLabel)}
            placeholder={formatMessage(messages.commentInputPlaceholder)}
            value={form.comment}
            onChange={({ target: { value } }) => setForm({ ...form, comment: value })}
            onBlur={() => validate(['comment'])}
            errors={validations.comment}
            rows={1}
            containerProps={{ className: 'w-full' }} // @TODO Fix <Input /> in react-voicearchive to avoid containerProps and labelClassName
            labelClassName="inline-block"
          />

          { external &&
          <>
            <Input
              required
              label={formatMessage(messages.labelName)}
              value={form.name}
              onChange={({ target: { value } }) => setForm({ ...form, name: value })}
              onBlur={() => validate(['name'])}
              errors={validations.name}
              containerProps={{ className: 'w-full' }} // @TODO Fix <Input /> in react-voicearchive to avoid containerProps and labelClassName
              labelClassName="inline-block"
            />

            <Input
              required
              label={formatMessage(messages.labelEmail)}
              value={form.email}
              onBlur={() => validate(['email'])}
              onChange={({ target: { value } }) => setForm({ ...form, email: value })}
              errors={validations.email}
              containerProps={{ className: 'w-full' }} // @TODO Fix <Input /> in react-voicearchive to avoid containerProps and labelClassName
              labelClassName="inline-block"
            />
          </>
          }

          <div className="pt-7">
            <Button
              type="submit"
              disabled={loading || !Object.keys(votes).length}
              onClick={loading ? undefined : onSubmit}
            >
              { loading ? (
                <span>{formatMessage(messages.buttonLoading)}</span>
              ) : (
                <span>{formatMessage(messages.buttonSubmit)}</span>
              ) }
            </Button>
          </div>
        </div>
      ) }
    </div>
  )
}

export default ProjectVote
